import WebapiCommon from '@common/util/webapi.common';
import * as commonActions from '@common/common.action';
import * as editorActions from '@componentes/editor/editor.action';
import { defaultDataEmpty } from './editor.data';
import { editorRunat, editorUrl } from '@constants/defaultValues';
import IntlMessage from '../../helpers/intlMessage';

export function mudarNomeAbaPrincipal(newName) {
  let frame = document.getElementById('iframe-editor');
  if (frame !== null) {
    frame.contentWindow.postMessage(
      {
        method: 'mudarNomeAbaPrincipal',
        title: newName,
        urlHost: editorUrl,
      },
      editorUrl,
    );
  }
}

export function addCustomButton(
  id,
  label,
  iconId,
  startsGroup,
  adicionarAoPrincipal,
  abaId,
  abaTexto,
  indice,
  mostrarTexto,
  modoToggle,
  selectedInicial,
) {
  const frame = document.getElementById('iframe-editor');
  if (frame !== null) {
    frame.contentWindow.postMessage(
      {
        method: 'adicionarBotao',
        commandId: id,
        commandLabel: label,
        commandIcon: iconId,
        beginGroup: startsGroup,
        addToHome: adicionarAoPrincipal,
        customTabId: abaId,
        customTabLabel: abaTexto,
        buttonIndex: indice,
        showText: mostrarTexto,
        toggleMode: modoToggle,
        initialToggleStatus: selectedInicial,
        urlHost: editorUrl,
      },
      editorUrl,
    );
  }
}

export const limpar = () => {

  const frame = document.getElementById('iframe-editor-component');

  if (frame !== null) {

    if (editorRunat === 'client') {
      frame.contentWindow.postMessage(
        {
          method: 'clearDocument'
        },
        editorUrl
      );
    }
  }
};


export const Inicializar = (laudo, etapa, dispatch, blank = false) => {

  dispatch(editorActions.editorReadOnly(false));
  dispatch(commonActions.showFadeCarregando(true));
  dispatch(commonActions.showEditor(true));
  dispatch(commonActions.editorInicializado(true));
  // dispatch(commonActions.autoSaveEditor(true));
  // dispatch(commonActions.etapaAtual(etapa));
  dispatch(commonActions.eventokeyUpFoiDisparadoNoEditor(false));
  dispatch(editorActions.textoInicial(true));


  Promise.all([WebapiCommon.getTextoLaudo(laudo, etapa)]).then(
    responseArray => {
      let tentativas = 0;
      let interval = setInterval(() => {
        if (window.$editor_carregado) {
          const frame = document.getElementById('iframe-editor-component');
          if (frame !== null && frame.contentWindow.length !== 0) {
            try {
              frame.style.display = 'block';

              const textRtf =
                responseArray[0].data.rtf !== null
                  ? responseArray[0].data.rtf
                  : '';

              const id =
                responseArray[0].data.id !== null
                  ? responseArray[0].data.id
                  : '';

              if (!blank) {

                if (!textRtf) {
                  dispatch(editorActions.editorRtf(textRtf));
                  dispatch(editorActions.idRtf(id));
                  dispatch(commonActions.preencherIdRtf(id));
                  dispatch(commonActions.showFadeCarregando(false));

                  frame.contentWindow.postMessage(
                    {
                      method: 'substituirTexto',
                      text: defaultDataEmpty,
                      type: 'rtf',
                      runat: editorRunat,
                      breakLine: false,
                      cleanBefore: true
                    },
                    editorUrl
                  );
                } else {
                  frame.contentWindow.postMessage(
                    {
                      method: 'substituirTexto',
                      text: textRtf,
                      type: 'rtf',
                      runat: editorRunat,
                      breakLine: false,
                      cleanBefore: true
                    },
                    editorUrl
                  );
                  dispatch(editorActions.editorRtf(textRtf));
                  dispatch(editorActions.idRtf(id));
                  dispatch(commonActions.preencherIdRtf(id));

                }
              }

              setTimeout(() => {
                dispatch(commonActions.showFadeCarregando(false));
              }, 3000);

              clearInterval(interval);
              dispatch(editorActions.editorInicializado(true));
            } catch (error) {
              console.log(error);
              clearInterval(interval);
              dispatch(commonActions.showFadeCarregando(false));
            }
          }
        } else {
          tentativas++;
          console.log(`Editor tentou carregar ${tentativas} ${editorUrl} vezes.`);

          if (tentativas >= 30) {
            clearInterval(interval);
            dispatch(commonActions.showFadeCarregando(false));
            dispatch(editorActions.editorInicializado(false));

            let msg =
              <IntlMessage id="message.errorEditor" />;
            dispatch(commonActions.showAlerta(
              'alerta',
              msg,
              3000,
              msg.length * 10 + 'px'
            ));
          }
        }
      }, 300);
    }
  );
};



// WEBPACK FOOTER //
// ./src/componentes/editor/editor.util.js